import type { SystemStyleObject } from "@mui/system";

import type { Theme } from "@mui/material";

/** The keyboard focus outline, for an sx array. */
export const focusRing =
  (offset = 2) =>
  (theme: Theme): SystemStyleObject<Theme> => ({
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.oscar.light.borders.electric}`,
      outlineOffset: `${offset}px`,
    },
  });

/** Spread last into an sx array so motion stops for people who ask for that. */
export const reducedMotion: SystemStyleObject<Theme> = {
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none",
    animation: "none",
  },
};
